import { render, staticRenderFns } from "./TraxUiModalDefault.vue?vue&type=template&id=d2db7ac2"
import script from "./TraxUiModalDefault.vue?vue&type=script&lang=js"
export * from "./TraxUiModalDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports